<template>
	<div id="contactContainer" class="container">
		<div class="row">
			<div id="contactHeader" class="col-12">
				<h1>
					Contact Us
				</h1>
				<p>We are here to help! For general enquires or if you would like to provide feedback on a product or service please get in touch below.</p>
			</div>
			<div class="col-12 col-lg-4">
				<div>
					<h2>
						General Enquiries
					</h2>
					<p><strong>Email: </strong> <a href="mailto:info@cherrytree.co.nz">info@cherrytree.co.nz</a></p>
					<p><strong>Phone: </strong><a href="tel:0800 243 779">0800 243 779</a></p>
				</div>
				<div>
					<h2>
						Product Enquiries
					</h2>
					<p><strong>Email: </strong> <a href="mailto:memberservices@cherrytree.co.nz">memberservices@cherrytree.co.nz</a></p>
					<p><strong>Phone: </strong><a href="tel:0800 243 779">0800 243 779</a></p>
				</div>
				<!--<div>
					<h2>
						Request a Price
					</h2>
					<p><strong>Email: </strong> <a href="mailto:quotes@cherrytree.co.nz">quotes@cherrytree.co.nz</a></p>
				</div>-->
				<div>
					<h2>
						Commercial Enquiries
					</h2>
					<p><strong>Email: </strong> <a href="mailto:simon@cherrytree.co.nz">simon@cherrytree.co.nz</a></p>
					<p><strong>Phone: </strong><a href="tel:04 477 4440">04 477 4440</a></p>
				</div>
			</div>
			<div class="col-12 col-lg-8">
				<div class="col-12">
					<h2>Send us a message</h2>
					<p>Fields marked with a <strong class="required-indicator">*</strong> are required.</p>
				</div>
				<form class="contactForm row mx-auto" v-on:submit.prevent="submitContact">

					<InputField
						v-validate="{required: true}"
						v-model="name"
						label="Name"
						:required="true"
						type="text"
						class="col-12 col-md-6"
						data-vv-validate-on="input"
						:error="errors.first('Name')"
					/>

					<InputField 
						v-validate="{required: email? false: true}"
						v-model="phone"
						label="Phone Number"
						type="tel"
						class="col-12 col-md-6"
						data-vv-validate-on="input"
						:error="errors.first('Phone Number')"
					/>

					<InputField 
						v-validate="{required: phone? false: true, email: true}"
						v-model="email"
						label="Email"
						:required="true"
						type="email"
						class="col-12"
						data-vv-validate-on="input"
						:error="errors.first('Email')"
					/>

					<InputField
						v-model="subject"
						label="Subject"
						class="col-12"
						type="text"
					/>

					<TextareaField
						v-model="message"
						label="Message"
						v-validate="'required'"
						:required="true"
						data-vv-validate-on="input"
						class="col-12"
						:error="errors.first('Message')"
					/>

					<div class="col-12">
						<ButtonWithLoading
							type="submit"
							:state="submitState"
							text="Send"
							loadingText="Sending"
							successText="Sent"
							errorText="Error Sending"
						></ButtonWithLoading>
					</div>
				</form>
				<!--<div v-if="errors.all().length > 0" class="alert alert-danger">
					<li v-for="(error, index) in errors.all()" :key="index">{{ error }}</li>
				</div>-->

				<div v-if="errorMessage" class="alert alert-danger">
					{{errorMessage}}
				</div>
			</div>
		
		</div>
	</div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";
// import Loading from "@/components/loading/Loading";
// import WordpressContentPage from "@/wordpress/WordpressContentPage";
import InputField from "@/components/forms/InputField";
import TextareaField from "@/components/forms/TextareaField";


import { postContact } from "@/network/contactRequests";
import { fetchUserDetails } from "@/network/userRequests"

export default {
	name: "ContactPage",
	props: ['pageSlug'],
	components: {
		ButtonWithLoading,
		// WordpressContentPage,
		// Loading,
		InputField,
		TextareaField
	},
	data() {
		return {
			loading:true,
			submitState: null,
			errorMessage: null,
			loggedIn: false,
			subject: "",
			message: "",
			phone: "",
			email: "",
			name: ""
		};
	},
	created() {
		if (this.pageSlug == "feedback-top-content") {
			this.subject = 'Feedback';
		}
		this.getData();
	},
	methods: {
		getData() {
			fetchUserDetails(
				(res) => {
					if (res.length > 0) {
						this.name = res.member_details.given_name + " " + res.member_details.family_name;
						this.email = res.member_details.email;
						this.phone = res.member_details.home_phone;
						this.loggedIn = true;
					}
				},
				(err) => {console.log(err)}
			)
		},
		wpContentLoaded() {
			this.loading = false;
		},
		submitContact() {
			this.$validator.validateAll().then(valid => {
				if (!valid) {
					return;
				}
				this.submitState = "loading";

				const { name, email, phone, message, subject } = this;
				let subjectSend = subject;
				if (subjectSend == "") {
					subjectSend = "From Website Contact Form"
				}

				postContact(
					{ name, email, phone, message, subject:subjectSend },
					() => { //success
						this.submitState = "success";

						// delay redirect so user sees success
						setTimeout(() => {
							this.submitState = null;
							this.errorMessage = "";
						}, 5000);
					},
					error =>{
						this.errorMessage = error.message || "Error with sending form";
						this.submitState = "error";
						setTimeout(() => {
							this.submitState = null
						}, 3000);
					}
				)
			});
		}
	},
	// beforeRouteUpdate (to, from, next) {
    // // called when the route that renders this component has changed,
    // // but this component is reused in the new route.
    // // For example, for a route with dynamic params `/foo/:id`, when we
    // // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
    // // will be reused, and this hook will be called when that happens.
    // // has access to `this` component instance.
	// 	this.name = to.params.name
	// 	this.loading = false;
	// 	next();
	// },
};
</script>

<style lang="scss" scoped>

	#contactContainer {
		#contactHeader {
			margin-top: 24px;
		}
		h2 {
			margin: 30px 0;
		}

		p {
			margin-bottom: 0;
		}
	}

</style>
